import React from 'react';
import {IProps} from './types';
import * as S from './styles';
import UpdatingFileBar from '@routes/private/Templates/components/NewTemplate/components/UpdatingFileBar/index';

const Files:React.FC<IProps> = (props) => {

  const handleDeleteTemplate = (index:number) => {
    if (props.files[index]) {
      props.setFiles([
        ...props.files.slice(0, index),
        ...props.files.slice(index + 1)
      ]);
    }
  }

  const handleRetryUpload = (index: number) => {
    if (props.files[index]) {
      props.setFiles([
        ...props.files.slice(0, index),
        {...props.files[index], data: undefined},
        ...props.files.slice(index + 1)
      ]);
      const fileProgressIndex = props.filesProgress.findIndex((fileProgress: any) => (fileProgress.id === props.files[index].id));
      if (fileProgressIndex >= 0) {
        props.setFilesProgress([
          ...props.filesProgress.slice(0, fileProgressIndex),
          ...props.filesProgress.slice(fileProgressIndex + 1)
        ]);
      }
    }
  }

  const returnFileProgress = (id: string) => {
    let fileProgress = {id: '', progress: 0, hasErrors: false };
    const fileProgressIndex = props.filesProgress.findIndex((fileProgress: any) => (fileProgress.id === id));
    if (fileProgressIndex >= 0) fileProgress = props.filesProgress[fileProgressIndex];
    return fileProgress;
  }

  return (
    <S.Root >
      <S.Title>Files</S.Title>
      {props.files.length === 0 &&
        <S.BoxEmpty>
          <S.Text>Upload or drag and drop files to see their progress here</S.Text>      
        </S.BoxEmpty>
      }
      {props.files.length > 0 &&
        <S.Box >
          <S.FileHeader>
            <S.FileNameLabel>
              Name
            </S.FileNameLabel>
            <S.FileUploadLabel>
              Upload
            </S.FileUploadLabel>
            <S.FileTagLabel>
              Tag
            </S.FileTagLabel>
          </S.FileHeader>
          {props.files.map((newFile:any, index:number) => {
              return (
                <UpdatingFileBar 
                  key={index} 
                  newFile={newFile} 
                  fileIndex={index}
                  currentIndex={props.currentIndex}
                  setCurrentIndex={props.setCurrentIndex}
                  handleDeteleTemplate={handleDeleteTemplate}
                  handleRetryUpload={handleRetryUpload}
                  fileProgress={returnFileProgress(newFile.id)} 
                />
              )
            })
          }
        </S.Box>
      }
    </S.Root >
  );
}

export default Files;